import urljoin from 'url-join';
import { EmbedConfig } from '../..';
import render from '../../designs/paper';

import ZeitungProWoff2 from '../../../../../../client/assets/ZeitungPro-Light.woff2';
import ZeitungProBoldWoff2 from '../../../../../../client/assets/ZeitungPro-Semibold.woff2';

import './styles/style.scss';

const additionalFonts = (config: EmbedConfig) => {
  const zeitungProWoff2Path = urljoin(config.goBaseUrl, ZeitungProWoff2);
  const zeitungProBoldWoff2Path = urljoin(config.goBaseUrl, ZeitungProBoldWoff2);

  return `
    @font-face {
      font-family: 'Zeitung Pro';
      font-style: normal;
      src: url('${zeitungProWoff2Path}') format('woff2');
    }

    @font-face {
      font-family: 'Zeitung Pro';
      font-style: normal;
      font-weight: 700;
      src: url('${zeitungProBoldWoff2Path}') format('woff2');
    }`;
};

render(additionalFonts);
